<div class="panel">
    <div class="title-text panel-header">
        {{ title }}
    </div>
    <div class="form-container">
    <ng-content select="[top-item]"></ng-content>
</div>
</div>